import type { JSX } from 'react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import type { CampaignClass } from '@feathr/blackbox';
import { CampaignLabelMap } from '@feathr/blackbox';
import { Chip } from '@feathr/components';
import { getIconForAction } from '@feathr/hooks';

import { campaignColorMap } from '../../styles/campaign';
import { getCampaignIcon } from '../CampaignIcons';

interface IProps {
  className?: string;
  cls: CampaignClass;
  name?: string;
  isMonetization?: boolean;
}

function CampaignTypeChip({
  className,
  cls,
  name,
  isMonetization = false,
}: Readonly<IProps>): JSX.Element {
  const { t } = useTranslation();

  return (
    <Chip
      className={className}
      name={name ?? 'campaign-type-chip'}
      prefix={getCampaignIcon(cls)}
      suffix={isMonetization && getIconForAction('monetization')}
      theme={campaignColorMap.get(cls)}
    >
      {CampaignLabelMap.get(cls) ?? t('Campaign')}
    </Chip>
  );
}

export default CampaignTypeChip;
